import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Link, useParams } from 'react-router-dom';
import MobileBottomNav from '@/components/MobileBottomNav';
import { IconAlertTriangle as AlertTriangle } from '@tabler/icons-react';
import { wrap, pageBg, displayTitle, eyebrow, bodyMuted, card, cardTitle, btnPrimary, btnGhost, glow } from '@/components/ui/design';

export default function OrderFailed() {
    const { sessionId } = useParams();
    return (
        <div className={`min-h-screen ${pageBg}`}>
            <Header />
            <section className="relative isolate overflow-hidden">
                <div className={glow} />
                <div className={`${wrap} flex min-h-[70vh] flex-col items-center justify-center py-12 sm:py-20`}>
                    <div className="flex w-full max-w-xl flex-col items-center text-center">
                        <div className="mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-red-100 ring-1 ring-red-200/60 dark:bg-red-900/30 dark:ring-red-400/20">
                            <AlertTriangle className="h-9 w-9 text-red-500 dark:text-red-400" />
                        </div>

                        <p className={eyebrow}>Checkout</p>
                        <h1 className={`${displayTitle} mt-4`}>
                            Payment Failed
                        </h1>

                        <p className={`${bodyMuted} mt-6 max-w-md`}>
                            We're sorry, but your payment could not be processed. This could be due to insufficient funds,
                            card restrictions, or other payment issues.
                        </p>

                        <div className={`${card} mt-10 w-full p-6 text-left sm:p-8`}>
                            <h3 className={`${cardTitle} mb-5`}>
                                What happened?
                            </h3>
                            <div className="space-y-3 text-sm text-grey40 dark:text-nightMuted">
                                <div className="flex items-start gap-3">
                                    <div className="mt-1.5 h-2 w-2 flex-shrink-0 rounded-full bg-red-400"></div>
                                    <p>Your payment was declined by your bank or card issuer</p>
                                </div>
                                <div className="flex items-start gap-3">
                                    <div className="mt-1.5 h-2 w-2 flex-shrink-0 rounded-full bg-red-400"></div>
                                    <p>No charges were made to your account</p>
                                </div>
                                <div className="flex items-start gap-3">
                                    <div className="mt-1.5 h-2 w-2 flex-shrink-0 rounded-full bg-red-400"></div>
                                    <p>Your tickets were not reserved</p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row">
                            <Link
                                to="/"
                                className={`${btnPrimary} w-full sm:flex-1`}
                            >
                                Return to Home
                            </Link>

                            <Link
                                to="/checkout"
                                className={`${btnGhost} w-full sm:flex-1`}
                            >
                                Try Again
                            </Link>
                        </div>

                        <div className="mt-10 w-full border-t border-grey90 pt-6 dark:border-white/10">
                            <p className="text-sm text-grey40 dark:text-nightMuted">
                                Need help? Contact our support team
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer hasMobileNav />
            <MobileBottomNav />
        </div>
    );
}
